




























































































































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
@Component({
  components: { Banner, SideBar, Swiper, SwiperSlide }
})
export default class AboutUs extends Vue {
  flag = false;
  flagUrl = "";
  flagName = "";
  ziliaoList = [
    {
      title: "品牌营销",
      list: [
        {
          field1: "华为投资控股有限公司 2023年年度报告",
          id: "AePA2fA16484645312201",
          field3: "2024-03-29",
          field4:
              "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/%E5%8D%8E%E4%B8%BA2023%E5%B9%B4%E5%BA%A6%E6%8A%A5%E5%91%8A.pdf",
          createDate: 1713495371
        },
        {
          field1: "华为投资控股有限公司 2021年年度报告",
          id: "AePA2fA1648464531220",
          field3: "2022-03-28",
          field4:
            "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/%E5%8D%8E%E4%B8%BA%E6%8A%95%E8%B5%84%E6%8E%A7%E8%82%A1%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%202021%E5%B9%B4%E5%B9%B4%E5%BA%A6%E6%8A%A5%E5%91%8A.pdf",
          createDate: 1648464531000
        },
        {
          field1: "华为投资控股有限公司2019年年度报告",

          id: "l133640171EHky378M8MF19sS4S1584968670934",
          field3: "2020-03-31",
          field4:
            "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/%E5%8D%8E%E4%B8%BA%E6%8A%95%E8%B5%84%E6%8E%A7%E8%82%A1%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B82019%E5%B9%B4%E5%B9%B4%E5%BA%A6%E6%8A%A5%E5%91%8A.pdf",
          createDate: 1584968670000
        }
      ]
    },
    {
      title: "行业洞察",
      list: [
        {
          field1: "新型工业互联网平台参考架构",
          dictCode: "0039002",
          content1: "",
          id: "YTfq35616348727241191",
          field3: "2024-04-18",

          field4:
              "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/%E6%96%B0%E5%9E%8B%E5%B7%A5%E4%B8%9A%E4%BA%92%E8%81%94%E7%BD%91%E5%B9%B3%E5%8F%B0%E5%8F%82%E8%80%83%E6%9E%B6%E6%9E%84.pdf",
          createDate: 1713495371
        },
        {
          field1: "工业数字化智能化2030",
          dictCode: "0039003",
          content1: "",
          id: "YTfq35616348727241192",
          field3: "2024-01-01",

          field4:
              "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/%E5%B7%A5%E4%B8%9A%E6%95%B0%E5%AD%97%E5%8C%96%E6%99%BA%E8%83%BD%E5%8C%962030.pdf",
          createDate: 1713495371
        },

        {
          field1: "智能世界2030报告",
          dictCode: "0039004",
          content1: "",
          id: "YTfq35616348727241193",
          field3: "2024-01-01",

          field4:
              "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/%E6%99%BA%E8%83%BD%E4%B8%96%E7%95%8C2030%E6%8A%A5%E5%91%8A.pdf",
          createDate: 1713495371
        },
        {
          field1: "智慧园区2030",
          dictCode: "0039005",
          content1: "",
          id: "YTfq35616348727241194",
          field3: "2024-01-01",

          field4:
              "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/%E6%99%BA%E6%85%A7%E5%9B%AD%E5%8C%BA2030.pdf",
          createDate: 1713495371
        },

        {
          field1: "数字能源2030产业报告",
          dictCode: "0039001",
          content1: "",
          id: "YTfq3561634872724119",
          field3: "2021-09-15",

          field4:
            "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/%E6%95%B0%E5%AD%97%E8%83%BD%E6%BA%902030%E4%BA%A7%E4%B8%9A%E6%8A%A5%E5%91%8A.pdf",
          createDate: 1634872724000
        },
        {
          field1: "计算2030产业报告",
          dictCode: "0039001",
          content1: "",
          id: "n2pWaWP1634872629760",
          field3: "2021-09-15",

          field4:
            "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/%E8%AE%A1%E7%AE%972030%E4%BA%A7%E4%B8%9A%E6%8A%A5%E5%91%8A.pdf",
          createDate: 1634872629000
        },
        {
          field1: "2021华为数字化转型洞察报告",
          dictCode: "0039001",
          content1: "",
          id: "03p2NI21634872027209",
          field3: "2021-10-15",

          field4:
            "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/2021%E5%8D%8E%E4%B8%BA%E6%95%B0%E5%AD%97%E5%8C%96%E8%BD%AC%E5%9E%8B%E6%B4%9E%E5%AF%9F%E6%8A%A5%E5%91%8A.pdf",
          createDate: 1634872027000
        },
        {
          field1: "《5G人才发展新思想白皮书》",
          dictCode: "0039001",
          content1: "",
          id: "dx72t1P1622685482108",
          field3: "2020-10-23",

          field4:
            "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/%E3%80%8A5G%E4%BA%BA%E6%89%8D%E5%8F%91%E5%B1%95%E6%96%B0%E6%80%9D%E6%83%B3%E7%99%BD%E7%9A%AE%E4%B9%A6%E3%80%8B.pdf",
          createDate: 1622685482000
        },
        {
          field1: "《全球联接指数 2020》方法论",
          dictCode: "0039001",
          content1: "",
          id: "f675tG71612406793781",
          field3: "2021-01-29",
          field4:
            "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/%E3%80%8A%E5%85%A8%E7%90%83%E8%81%94%E6%8E%A5%E6%8C%87%E6%95%B0%202020%E3%80%8B%E6%96%B9%E6%B3%95%E8%AE%BA.pdf",
          createDate: 1612406793000
        },
        {
          field1: "《全球联接指数 2020》",
          dictCode: "0039001",
          content1: "",
          id: "QQ7230s1612406759106",
          field3: "2021-01-26",

          field4:
            "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/%E3%80%8A%E5%85%A8%E7%90%83%E8%81%94%E6%8E%A5%E6%8C%87%E6%95%B0%202020%E3%80%8B.pdf",
          createDate: 1612406759000
        },
        {
          field1:
            "华为全球产业展望GIV 2025（Global Industry Vision 2025）：智能世界，触手可及",
          dictCode: "0039001",
          content1: "",
          id: "eN4QQ1ST0RnezKIRL139006O5661585882472002",
          field3: "2019-08-12",

          field4:
            "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/%E5%8D%8E%E4%B8%BA%E5%85%A8%E7%90%83%E4%BA%A7%E4%B8%9A%E5%B1%95%E6%9C%9BGIV%202025%EF%BC%88Global%20Industry%20Vision%202025%EF%BC%89%EF%BC%9A%E6%99%BA%E8%83%BD%E4%B8%96%E7%95%8C%EF%BC%8C%E8%A7%A6%E6%89%8B%E5%8F%AF%E5%8F%8A.pdf",
          createDate: 1585882472000
        },
        {
          field1: "中国数字化转型人才培养顶层设计",
          dictCode: "0039001",
          content1: "",
          id: "IlGG0EdZqe5bqYpzK1L4r99p9al1581389729518",
          field3: "2020-02-11",

          field4:
            "https://ict-static.obs.cn-east-2.myhuaweicloud.com/zjhuawei/%E4%B8%AD%E5%9B%BD%E6%95%B0%E5%AD%97%E5%8C%96%E8%BD%AC%E5%9E%8B%E4%BA%BA%E6%89%8D%E5%9F%B9%E5%85%BB%E9%A1%B6%E5%B1%82%E8%AE%BE%E8%AE%A1.pdf",
          createDate: 1581389729000
        }
      ]
    }
  ];
  SwiperIndex = {
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    speed: 100,
    slidesPerView: 1,
    loop: true,
    autoplay: false,
    autoplayDisableOnInteraction: false
  };
  lately = [];
  report = [];
  bannerData = {
    font1: "浙江华为",
    font2: "",
    font3: "发展数智人才，加速智能世界到来",
    button: "",
    style: {
      "background-image": 'url("' + require("../../assets/pic55.png") + '")',
      height: "280px"
    }
  };
  intList: any = [];
  about = {};
  url = "";
  // 背景图样式文案
  list = {
    style: {
      "background-image": `url(${require("../../assets/about_02.jpg")})`,
      height: "280px"
    },
    font1: "浙江华为",
    font2: "",
    font3: "发展数智人才，加速智能世界到来",
    font4: "",
    font5: "",
    button: ""
  };
  //computed

  mounted() {
    if (this.$route.query.scroll && this.$route.query.scroll == "1") {
      this.$nextTick(() => {
        window.scrollTo(0, document.documentElement.scrollHeight);
      });
    }

    this.url = "https://ict-static.obs.cn-east-2.myhuaweicloud.com";
    //专题报导
    this.intList = [
      {
        tag1: 0,
        updateDate: 1639476882000,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 5,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "华为全球培训中心是华为面向全球高端客户的重要窗口",
        dictCode: "051",
        content1: "业务高峰可同时容纳约2200人/天，每年可接待30000+ 学员",
        id: "39quf26P039O1J599a6yCzA92yz1585125458983",
        field2: "/zjhuawei/aboutus/aboutus-2.jpg",
        group: "051",
        createDate: 1585125458000
      },
      {
        tag1: 0,
        updateDate: 1639476889000,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 3,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "古典建筑包裹科技内核，丰富配套满足学员需求",
        dictCode: "051",
        content1: "总占地面积13.2万㎡，内设运动场、图书馆、咖啡厅、健身房",
        id: "7Nd28R62m7H7z4O11E7wf7O74141584951377844",
        field2: "/zjhuawei/aboutus/aboutus-3.jpg",
        group: "051",
        createDate: 1584951377000
      },
      {
        tag1: 0,
        updateDate: 1585617788000,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 2,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "拥有全系列华为设备，覆盖全方位的ICT解决方案场景",
        dictCode: "051",
        content1: "8大产品线设备，5大实训区",
        id: "05J5v176096n4p323F967p21Rqj1585371296179",
        field2: "/zjhuawei/aboutus/aboutus-4.jpg",
        group: "051",
        createDate: 1585371296000
      },
      {
        tag1: 0,
        updateDate: 1586762338000,
        plural: 0,
        reading: 0,
        collection: 0,
        sort: 1,
        tag2: 0,
        isShow: 1,
        tag3: 0,
        field1: "数字化教学，支撑现场与远程同步教学、虚拟教学",
        dictCode: "051",
        content1: "拥有143 间大中小教室，可满足 6-48 不同人数的开班需求",
        id: "464C4xet28g8Lx6X9iy15140B221585371179624",
        field2: "/zjhuawei/aboutus/aboutus-5.jpg",
        group: "051",
        createDate: 1585371179000
      }
    ];
    //关于浙华
    this.about = {
      tag1: 0,
      updateDate: 1597746768000,
      plural: 0,
      reading: 0,
      collection: 0,
      sort: 1,
      tag2: 0,
      isShow: 1,
      tag3: 0,
      field1: "关于浙江华为",
      dictCode: "050",
      content1:
        '<p><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 18px;">浙江华为通信技术有限公司成立于1999年，是华为专注于数智人才学习与发展业务的合资子公司，是华为培训的重要力量。浙江华为秉承“以客户为中心”的理念，奉行“能力为先，以质取胜”的原则，为全球170多个国家和地区提供包括ICT（通信与信息）技术培训、产教融合建设方案、数字化领导力实践、数字化转型能力咨询、华为认证培训等具有“数智化+行业化”特色的人才发展服务。2012年迄今已累计培养85万+优秀人才，目前年培训人次可达10万+，始终如一践行“用最优秀的人培养更优秀的人”，持续助力客户在数字化转型背景下的人才发展和商业成功。</span></p><p><br/></p>',
      id: "UM8A6723535Sad7h02850z40bgf1584951193038",
      field2: "/zjhuawei/aboutus/aboutus-1.jpg",
      group: "050",
      createDate: 1584951193000
    };
  }
  on_top_enter() {
    (this.$refs.indexSwiper as any).$swiper.autoplay.stop();
  }
  on_top_leave() {
    (this.$refs.indexSwiper as any).$swiper.autoplay.start();
  }
  //是否下载
  xiazai(file, s) {
    this.flag = true;
    this.flagUrl = file;
    this.flagName = s;
  }
  hideFlag() {
    this.flag = false;
    this.flagUrl = "";
    this.flagName = "";
  }
  downloadFile() {
    const a = document.createElement("a");
    a.style.display = "none";
    a.download = this.flagName;
    a.href = this.flagUrl;
    document.body.appendChild(a);
    a.click(); // 触发a标签的click事件
    document.body.removeChild(a);
    this.flag = false;
  }
}
